<template>
    <div :class="`convention-section`" :id="`section-${annotationsInSection.key}`">
        <annotation-title
            :title="titleContent"
            :id="annotationsInSection.key"
            :type="annotationsInSection.type"
        />
        <annotation-body
            :annotations="annotationsInSection.annotations"
            :insurers="insurers"
            :annotationOptions="annotationOptions"
            :titlePath="annotationsInSection.key"
            :sections="sections"
        />
        <div class="convention-section-children" v-if="annotationsInSection.children">
            <convention-compact-info-annotation
                v-for="child in annotationsInSection.children"
                :key="child.key"
                :annotationsInSection="child"
                :insurers="insurers"
                :sections="sections"
                :annotationOptions="annotationOptions"
            />
        </div>
    </div>
</template>

<script>
import AnnotationTitle from "./annotationSection/AnnotationTitle.vue";
import AnnotationBody from "./annotationSection/AnnotationBody.vue";

export default {
    components: { AnnotationTitle, AnnotationBody },
    name: "ConventionCompactInfoAnnotation",
    props: ["annotationsInSection", "insurers", "sections", "annotationOptions"],
    computed: {
        titleContent() {
            if (this.annotationsInSection.title.indexOf("|") > -1) {
                return this.annotationsInSection.title.split("|")[1].trim();
            }
            return this.annotationsInSection.title;
        },
    },
};
</script>

<style lang="sass">
.convention-section-note-di
    border: 2px solid rgb(242, 159, 5)
    width: 70%
    margin-top: 32px
    margin-bottom: 32px
    .title-note-di
        background: rgb(242, 159, 5)
        color: white
        padding: 2px 8px
        width: 100%
        font-style: normal
        margin-bottom: 8px
    .convention-section-title
        padding-left: 8px
    .convention-body
        padding-left: 8px
    .cc-legend
        margin-left: $cc-legend-margin - 10px

.subtitle
    font-size: 16px
    font-style: italic
    font-weight: 400

.note-di
    border: 2px solid rgb(242, 159, 5)
    width: 70%
    margin-top: 48px
    margin-bottom: 32px
    padding: 8px
    position: relative

    &:before
        content: "Précisions pour la rubrique Divers"
        position: absolute
        top: -26px
        left: 0
        right: 0
        background: rgb(242, 159, 5)
        margin: 0 -2px
        color: white
        padding: 2px 8px
        font-size: 16px
        font-style: normal
    .cc-legend
        margin-left: $cc-legend-margin - 2px
</style>
